import { getEssayByUser } from '../../../core/queries/essays-queries/essayFunction';
import { useMutation } from '@tanstack/react-query';

type essayProps = {
  slug: string;
  tryNumber?: number;
}

export function useAlternativeGetUserEssay() {
  const { mutate, data, isError, isPending } = useMutation({
    mutationKey: ['alternativeUserEssay'],
    mutationFn: ({ slug, tryNumber }: essayProps) => getEssayByUser(slug, tryNumber),
    retry: false
  });

  return {
    isError,
    isPending,
    data,
    mutate
  }
}
